import { combineReducers } from 'redux';

import accurateResponseData from './reducers/accurateResponseDataReducer';
import answers from './reducers/answers';
import bookInfo from './reducers/book_info';
import config from './reducers/config';
import evidenceTag from './reducers/evidence_tag';
import graphicOrganizer from './reducers/graphic_organizer';
import inlineActivities from './reducers/activity';
import interact from './reducers/interact';
import postReading from './reducers/post_reading';
import quest from './reducers/quest';
import readingMode from './reducers/reading_mode';
import revealWords from './reducers/reveal_words';
import userSettings from './reducers/user_settings';
import captions from './reducers/captions';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import screenReducer from './reducers/screenReducer';

export default combineReducers({
  accurateResponseData,
  answers,
  bookInfo,
  config,
  evidenceTag,
  graphicOrganizer,
  inlineActivities,
  interact,
  postReading,
  quest,
  readingMode,
  revealWords,
  userSettings,
  captions,
  gameDetailsReducer,
  screen: screenReducer,
});
